/**
 * @namespace Forms
 * @memberof Promega.Components
 * @description Monitors focus/blur on form input elements within the page, turning validation styles on or off depending on how the user has interacted with the input. Does not expose any methods externally.
 */

// Since some browsers show field validity before you've even entered anything,
// we only show valid / invalid styles after the user has interacted with ("touched") the input at least once.
function updateInputStatus(event) {
    if (event.target.classList.contains("allow-validation-styles")) {
        const tagName = event.target.tagName.toLowerCase();
        if ((tagName === "select" && event.type === "change")
            || (tagName === "input" && event.type === "focusout")
            || (tagName === "textarea" && event.type === "focusout")) {
            event.target.classList.add("touched");
        }
    }
}

document.addEventListener("focusout", updateInputStatus);
document.addEventListener("change", updateInputStatus);

//Validation
const inputs = Array.from(document.querySelectorAll("[data-validate = inputs-container] input"));

function showValidationMessage(event) {  
    const inputEl = event.target;

    event.preventDefault();
    inputEl.focus();
    inputEl.parentElement.querySelector('.input-validation-message').removeAttribute("hidden");
}

function checkInputValidity(event) {
    if (event.target.checkValidity() === true) {
        const messages = Array.from(event.target.parentElement.querySelectorAll('.input-validation-message'));
        messages.forEach(message => {
            if (!message.hasAttribute("hidden")) {
                message.setAttribute("hidden", "hidden")
            }
        })
    }
}

function addValidationClass(event) {
    event.target.classList.add("touched");
    if (event.target.validity.valid === false) {
        event.target.parentElement.querySelector('.input-validation-message').removeAttribute("hidden");
    }
}

function addValidationClassToAll(event) {
    inputs.forEach(input => { input.classList.add("touched") });
}

if (inputs) {
    inputs.forEach(input => {
        input.addEventListener("invalid", showValidationMessage);
        input.addEventListener("input", checkInputValidity);
        input.addEventListener("blur", addValidationClass);
    })
}

// If the user clicks "Submit," enable validation styles on all form elements.
if (document.querySelector('[data-validate = submit-button]')) {
    document.querySelector('[data-validate = submit-button]').addEventListener("click", addValidationClassToAll);
}